import { useCallback } from 'react';
import { bridge } from 'shared/src/utils';

export const useLogClickSearch = () => {
  return useCallback(() => {
    bridge.logAnalyticsEvent({
      name: 'CLICK_SEARCH',
      analytics: {
        SCREEN: 'GOODS_DETAIL',
      },
    });
  }, []);
};
